/* Block - Image Grid.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-image-grid.scss";
import rsCardLink from '../../js/component/_card';

rsCardLink.init('.rs-card-container');
